import apiClient from "./apiClient";
import {removeNullFields} from "@/utils/utils";

const BASE_URL = process.env.VUE_APP_BASE_URL as string;

const intergovExpensesService = {
    async getAll(params: any): Promise<any> {
        try {
            const paramsCopy = structuredClone(params);
            paramsCopy.filter = removeNullFields(paramsCopy.filter);
            const response = await apiClient.post<any>(
                `${BASE_URL}/api/v1/intergov-expenses/all`,
                paramsCopy
            )
            return response.data;
        } catch (error) {
            console.error("Error fetching advance-deduction list", error);
            throw error;
        }
    },

    async findById(studentId: string): Promise<any> {
        try {
            const response = await apiClient.get<any>(`${BASE_URL}/api/v1/intergov-expenses/findById/${studentId}`);
            return response.data;
        } catch (error) {
            console.error("Error findById advance-deduction", error);
            throw error;
        }
    },

    async findById4Edit(studentId: string): Promise<any> {
        try {
            const response = await apiClient.get<any>(`${BASE_URL}/api/v1/intergov-expenses/findById4Edit/${studentId}`);
            return response.data;
        } catch (error) {
            console.error("Error findById advance-deduction", error);
            throw error;
        }
    },

    async save(item: any): Promise<any> {
        try {
            const response = await apiClient.post<any>(
                `${BASE_URL}/api/v1/intergov-expenses/save`,
                item
            );
            return response.data;
        } catch (error) {
            console.error("Error save advance-deduction", error);
            throw error;
        }
    },

    async deleteById(id: string): Promise<any> {
        try {
            const response = await apiClient.delete<any>(`${BASE_URL}/api/v1/intergov-expenses/deleteById/${id}`);
            return response.data;
        } catch (error) {
            console.error("Error deleteById advance-deduction", error);
            throw error;
        }
    },
    async generateAndGetXls(uuid: string, params: any): Promise<any> {
        try {
            const paramsCopy = structuredClone(params);
            paramsCopy.filter = removeNullFields(paramsCopy.filter);

            return await apiClient.post<any>(
                `${BASE_URL}/api/v1/intergov-expenses/generate/xls/${uuid}`,
                paramsCopy,
                {
                    responseType: "blob"
                }
            )
        } catch (error) {
            console.error("Error fetching directory list:", error);
            throw error;
        }
    },

}

export default intergovExpensesService;
